<template>
    <div>
      <loadingcomp
        v-bind:mesaj="loadingmesaj"
        v-model="loadingvmodel"
      ></loadingcomp>
      <snackbarcomp v-bind:mesaj="text1" v-model="snackbar"></snackbarcomp>
  
      <v-dialog
        persistent
        max-width="850px"
        v-model="dialog"
        @keydown.esc="cancel"
      >
        <v-card>
          <v-card-title style="background-color: #01579b">
            <span class="headline white--text">Otomatik Kapanış Fişi Oluştur</span>
          </v-card-title>
          <v-card-text class="pa-4">
            <v-layout wrap>
              <v-flex xs12 sm12 md12>
                <v-form ref="referansbirlestir">
                  <v-flex xs12 sm12 md12>
                    <v-layout row wrap>
                      <v-flex xs12 sm12 md12>
                        <blockquote>
                          Otomatik Kapanış Fişi Oluşturma İşlemi Yapılacaktır. İşleme Devam Edilmesini İstiyor musunuz..?
                         </blockquote>
                       
                      </v-flex>
                     
                    </v-layout>
                    <v-layout row wrap>
                      <v-flex xs12 sm12 md12>
              <v-checkbox v-model=dovizsayristir
      label="Dövizli Muhasebe Hesapları için Merkez Bankası 30 Aralık 
      Alış Kuruna Göre Döviz Tutarları Set Edilsin" false-value="0"
    true-value="1"
    ></v-checkbox>
            </v-flex>
             
              </v-layout>
                   
                  </v-flex>
                </v-form>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions class="pt-0">
            <v-spacer></v-spacer>
            <v-btn color="primary darken-1" text @click.native="close()">{{
              $t("cancel_button")
            }}</v-btn>
            <v-btn color="primary darken-1" text @click.native="makeChange()">
              {{ 'Oluştur' }}
            </v-btn>
          
          </v-card-actions>
        </v-card>
      </v-dialog>
  
     
    </div>
  </template>
  
  <script>
 
  import auth from "../../../../../api/auth";
  import loadingcomp from "@/components/app/customcomp/loadingcomp";
  import snackbarcomp from "@/components/app/customcomp/snackbarcomp";
  
  export default {
    data() {
      return {
        dovizsayristir:0,
        seciliCariFirma:null,
        seciliMuhasebeFirma:null,
        dialog: false,
        credentials: JSON.parse(window.localStorage.getItem("credentials")),
        loadingvmodel: false,
        text1: null,
        snackbar: false,
        loadingmesaj: "Referans Birleştirme İşlemi"
      };
    },
    components: {
      
      loadingcomp,
      snackbarcomp,
    },
    methods: {
        close()
        {
           this.dialog=false;
        },
      makeChange() {
       
        this.loadingvmodel = true
        let Params = {
          WithCurrency :this.dovizsayristir,
          CompanyID : this.credentials.MuhasebeSirketNo,
          UserID:this.credentials.UserID
      };
          this.$http.post(auth.API_URL + 'api/AccountingParameters/CreateAutoClosingFiche', Params, {
            headers: {
              'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
          }).then((response) => {
  
            this.loadingvmodel = false
            this.text1 =  response.body.ResponseMessage;
            this.snackbar =true;
  
          }, (response) => {
            if (response.status === 0) {
              this.text1 = 'Service-'
              this.snackbar =true;
              this.loadingvmodel = false
            } else {
              this.text1 = 'Service-'
              this.snackbar =true;
              this.loadingvmodel = false
            }
          })
        
         
          this.controlDialog = false;
          this.dialog=false;
      },
      open() {
        this.dialog = true;
      },
     
    },
  };
  </script>
  
  <style>
  </style>
  